import Deposit from './deposit';
import Referral from './referral';
import Social from './social';
import TestYourLuck from './testyourluck';
import Tournament from './tournament';
import VIP from './vip';
import Wheel from './wheel';
import BonusZone from './bonus_zone';

export default {
    Deposit,
    Referral,
    Social,
    TestYourLuck,
    Tournament,
    VIP,
    Wheel,
    BonusZone
}